<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_223_1171)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 21.2545C7.94118 21.2545 4.24551 17.5588 4.24551 13C4.24551 8.44118 7.94118 4.74551 12.5 4.74551C17.0588 4.74551 20.7545 8.44118 20.7545 13C20.7545 17.5588 17.0588 21.2545 12.5 21.2545ZM2.49551 13C2.49551 7.47468 6.97468 2.99551 12.5 2.99551C18.0253 2.99551 22.5045 7.47468 22.5045 13C22.5045 18.5253 18.0253 23.0045 12.5 23.0045C6.97468 23.0045 2.49551 18.5253 2.49551 13ZM14.3615 15.54C14.9575 15.54 15.3961 15.5384 15.7304 15.526C15.5888 15.2229 15.3899 14.832 15.1177 14.3018L13.2562 10.676C12.937 10.0543 12.6969 9.59037 12.5 9.24016C12.3031 9.59037 12.063 10.0543 11.7438 10.676L9.88232 14.3018C9.6101 14.832 9.41123 15.2229 9.26958 15.526C9.6039 15.5384 10.0425 15.54 10.6385 15.54H14.3615ZM12.017 8.50942C12.017 8.50927 12.0191 8.51109 12.0233 8.51534C12.0191 8.51169 12.017 8.50957 12.017 8.50942ZM12.983 8.50942C12.983 8.50957 12.9809 8.51169 12.9767 8.51534C12.9809 8.51109 12.983 8.50927 12.983 8.50942ZM7.40025 16.6676C7.78038 17.29 8.73308 17.29 10.6385 17.29H14.3615C16.2669 17.29 17.2196 17.29 17.5998 16.6676C17.9799 16.0451 17.5448 15.1976 16.6745 13.5025L14.813 9.87672C13.8003 7.90417 13.2939 6.9179 12.5 6.9179C11.7061 6.9179 11.1998 7.90417 10.187 9.87672L8.32551 13.5025C7.45525 15.1976 7.02013 16.0451 7.40025 16.6676Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_223_1171">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
